import { render, staticRenderFns } from "./LuckDeliveryForm.vue?vue&type=template&id=e4bcd000&scoped=true"
import script from "./LuckDeliveryForm.vue?vue&type=script&lang=js"
export * from "./LuckDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./LuckDeliveryForm.vue?vue&type=style&index=0&id=e4bcd000&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bcd000",
  null
  
)

export default component.exports